const getters = {
  getOtherLanguage(state, getters) {
    return getters.getLanguage == 'zh' ? 'en' : 'zh'
  },
  getLanguage(state, getters) {
    return state.app.language || 'en'
  }
}
export default getters
